import React, { useRef, useState } from 'react';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { Container, Hovering, Image } from './styles';

export default function AvatarPicker({ imageUrl, setImageUrl, width, onClick = true }) {
  const inputRef = useRef(null);
  const [hovering, setHovering] = useState(false);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 2;

    if (!isJpgOrPng || !isLt2M) {
      message.error('Apenas imagens JPG/PNG menores que 2MB');
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setImageUrl(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleClick = () => {
    if (imageUrl) {
      setImageUrl(null);
      inputRef.current.value = null;
    } else {
      inputRef.current.click();
    }
  };

  return (
    <Container
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      onClick={onClick ? handleClick : null}
      width={width}
    >
      {imageUrl ? (
        <Image src={imageUrl} alt="Avatar" />
      ) : (
        <div style={{ textAlign: 'center', color: '#999' }}>
          <FaPlus size={24} />
          <div style={{ fontSize: 12, marginTop: 8 }}>Selecionar</div>
        </div>
      )}

      {hovering && imageUrl && onClick && (
        <Hovering>
          <FaTrash />
          Remover
        </Hovering>
      )}

      <input
        ref={inputRef}
        type="file"
        accept="image/png, image/jpeg"
        style={{ display: 'none' }}
        onChange={handleImageChange}
      />
    </Container>
  );
}
